import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function MechanismSection() {
  return <section className="py-20 px-6 bg-sage text-cream my-16" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <FadeIn data-id="element-73">
          <h3 className="text-sm font-sans font-bold tracking-widest text-cream/80 uppercase mb-4 text-center" data-id="element-74">
            The Unique Mechanism
          </h3>
          <h2 className="font-serif text-3xl md:text-5xl text-cream mb-8 text-center leading-tight" data-id="element-75">
            The Anti-Inflammatory Kitchen Reset
          </h2>

          <div className="space-y-6 text-lg text-cream/90 font-sans leading-relaxed" data-id="element-76">
            <p data-id="element-77">
              Instead of supplements, we use physics and food chemistry. By
              shifting to a "Cooked-Only" sequence, we pre-digest your fiber for
              you, giving your gut a 72-hour holiday.
            </p>
            <p data-id="element-78">
              We use a specific Osmotic Ratio (Salt-Water-Lemon) to trigger your
              kidneys to dump "bloat water" naturally, alongside lymphatic
              drainage hacks that manually move trapped air out of your system.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}